import React, { useState } from 'react';

function TermsPopup({ lang }) {
  const [open, setOpen] = useState(false);

  const terms = {
    es: `Términos y Condiciones de Uso
Estos Términos y Condiciones de Uso rigen su acceso y utilización del sitio web de Conlogar S.A., así como la compra de cualquier producto ofrecido en nuestra plataforma. Al acceder y utilizar nuestro sitio web, usted acepta estar sujeto a estos Términos y Condiciones en su totalidad. Si no está de acuerdo con alguna parte de estos términos, le pedimos que no utilice nuestro sitio.

1. Información General
Nombre de la empresa: Conlogar S.A.
Cédula jurídica: 3-101-226819
Domicilio social: Costa Rica, Cartago, Cruce de Taras contiguo a la Policía de Tránsito.
Correo electrónico de contacto: camitexcr@gmail.com
Actividad principal: Venta de camisetas e insumos textiles.

2. Capacidad Legal
Al utilizar este sitio web, usted declara ser mayor de edad en su país de residencia o tener el consentimiento de un padre o tutor legal para hacerlo. Usted garantiza que toda la información que nos proporcione es veraz, precisa y completa.

3. Propiedad Intelectual
Todo el contenido presente en este sitio web, incluyendo, pero no limitado a, textos, gráficos, logotipos, iconos, imágenes, clips de audio, descargas digitales, compilaciones de datos y software, es propiedad de Conlogar S.A. o de sus proveedores de contenido y está protegido por las leyes de derechos de autor y otras leyes de propiedad intelectual aplicables.

4. Productos y Precios
Nos esforzamos por mostrar la información más precisa sobre los productos, incluyendo descripciones, imágenes y precios. Sin embargo, no garantizamos que dicha información sea completamente libre de errores. En caso de un error en el precio de un producto, nos reservamos el derecho de cancelar o rechazar cualquier pedido realizado con el precio incorrecto.
Los precios de los productos están sujetos a cambios sin previo aviso. Los precios mostrados en el sitio web incluyen el Impuesto al Valor Agregado (IVA). El IVA aplicable se calculará y se mostrará en el total de su compra durante el proceso de pago. Los precios no incluyen los costos de envío. Cualquier costo adicional, como impuestos de importación o aranceles aduaneros (si aplica para envíos internacionales), será responsabilidad del comprador.
La disponibilidad de los productos puede variar. Nos reservamos el derecho de limitar las cantidades de cualquier producto que ofrecemos.

5. Proceso de Compra
Para realizar una compra, usted deberá seleccionar los productos deseados y agregarlos a su carrito de compras.
Deberá proporcionar información precisa y actualizada para el envío y facturación.
Una vez realizado el pedido, recibirá un correo electrónico de confirmación. Este correo electrónico no implica la aceptación de su pedido, sino una confirmación de que lo hemos recibido.
Nos reservamos el derecho de aceptar o rechazar cualquier pedido a nuestra entera discreción.

6. Pagos
Aceptamos los siguientes métodos de pago: SINPE Móvil, transferencia bancaria y tarjeta de crédito/débito de forma presencial (en nuestro establecimiento físico).
Todos los pagos deben ser realizados en Colones Costarricenses (CRC).
La información de pago es procesada de forma segura por nuestros proveedores de servicios de pago. Conlogar S.A. no almacena información sensible de tarjetas de crédito.

7. Envíos y Entregas
Nos esforzamos por despachar los pedidos en el menor tiempo posible. Los plazos de entrega estimados se indican en la sección de envío de nuestro sitio web. Tenga en cuenta que estos son solo estimaciones y pueden variar debido a factores externos.
Los costos de envío se calcularán y se mostrarán antes de que usted confirme su pedido.
El riesgo de pérdida y el título de los productos le serán transferidos en el momento de la entrega al transportista.
Es su responsabilidad asegurarse de que la dirección de envío proporcionada sea correcta y completa. No nos hacemos responsables de los retrasos o pérdidas causados por direcciones incorrectas o incompletas.

8. Política de Devoluciones y Reembolsos
Queremos que esté satisfecho con su compra. Si por alguna razón no lo está, puede solicitar una devolución dentro de los 15 días siguientes a la recepción de su pedido.
Para ser elegible para una devolución, el artículo debe estar sin usar y en las mismas condiciones en que lo recibió, y en su embalaje original.
Artículos personalizados (estampados o bordados a solicitud del cliente) y prendas de ropa interior no son elegibles para devolución por razones de higiene o personalización, a menos que presenten un defecto de fábrica.
Los gastos de envío de la devolución son responsabilidad del cliente, a menos que el producto recibido sea defectuoso o incorrecto.
Los reembolsos se procesarán a través del mismo método de pago utilizado en la compra original, dentro de los 7 días hábiles posteriores a la recepción y verificación del artículo devuelto.

9. Limitación de Responsabilidad
Conlogar S.A. no será responsable de ningún daño indirecto, incidental, especial, consecuencial o punitivo, incluyendo, sin limitación, pérdida de beneficios, datos, uso, buena voluntad u otras pérdidas intangibles, que resulten de (i) su acceso o uso o incapacidad de acceso o uso del Servicio; (ii) cualquier conducta o contenido de terceros en el Servicio; (iii) cualquier contenido obtenido del Servicio; y (iv) el acceso no autorizado, uso o alteración de sus transmisiones o contenido, ya sea basado en garantía, contrato, agravio (incluyendo negligencia) o cualquier otra teoría legal, hayamos o no sido informados de la posibilidad de tales daños, e incluso si un remedio establecido aquí se encuentra que ha fallado en su propósito esencial.

10. Modificaciones a los Términos y Condiciones
Nos reservamos el derecho de modificar estos Términos y Condiciones en cualquier momento. Cualquier cambio será efectivo inmediatamente después de su publicación en nuestro sitio web. Es su responsabilidad revisar estos Términos y Condiciones periódicamente para estar al tanto de las actualizaciones. El uso continuado de nuestro sitio web después de la publicación de los cambios constituirá su aceptación de dichos cambios.

11. Ley Aplicable y Jurisdicción
Estos Términos y Condiciones se rigen e interpretan de acuerdo con las leyes de Costa Rica, sin dar efecto a sus principios de conflicto de leyes. Usted acepta someterse a la jurisdicción exclusiva de los tribunales ubicados en Cartago, Costa Rica para la resolución de cualquier disputa que surja en relación con estos Términos y Condiciones.

12. Contacto
Si tiene alguna pregunta sobre estos Términos y Condiciones, no dude en contactarnos a través de camitexcr@gmail.com.
`,
    en: `Terms and Conditions of Use
These Terms and Conditions of Use govern your access to and use of the Conlogar S.A. website, as well as the purchase of any product offered on our platform. By accessing and using our website, you agree to be bound by these Terms and Conditions in their entirety. If you do not agree with any part of these terms, please do not use our site.

1. General Information
Company name: Conlogar S.A.
Registered address: Costa Rica, Cartago, Cruce de Taras next to the Traffic Police.
Contact email: camitexcr@gmail.com
Main activity: Sale of t-shirts and textile supplies.

2. Legal Capacity
By using this website, you declare that you are of legal age in your country of residence or have the consent of a parent or legal guardian to do so. You guarantee that all information you provide to us is true, accurate, and complete.

3. Intellectual Property
All content on this website, including but not limited to text, graphics, logos, icons, images, audio clips, digital downloads, data compilations, and software, is the property of Conlogar S.A. or its content providers and is protected by applicable copyright and other intellectual property laws.

4. Products and Prices
We strive to display the most accurate information about products, including descriptions, images, and prices. However, we do not guarantee that such information is completely error-free. In the event of a pricing error, we reserve the right to cancel or refuse any order placed at the incorrect price.
Product prices are subject to change without prior notice. Prices shown on the website include Value Added Tax (VAT). The applicable VAT will be calculated and shown in the total purchase during checkout. Prices do not include shipping costs. Any additional costs, such as import taxes or customs duties (if applicable for international shipments), will be the responsibility of the buyer.
Product availability may vary. We reserve the right to limit the quantities of any product we offer.

5. Purchase Process
To make a purchase, you must select the desired products and add them to your shopping cart.
You must provide accurate and up-to-date information for shipping and billing.
Once the order is placed, you will receive a confirmation email. This email does not imply acceptance of your order, but a confirmation that we have received it.
We reserve the right to accept or reject any order at our sole discretion.

6. Payments
We accept the following payment methods: SINPE Móvil, bank transfer, and credit/debit card in person (at our physical location).
All payments must be made in Costa Rican Colones (CRC).
Payment information is securely processed by our payment service providers. Conlogar S.A. does not store sensitive credit card information.

7. Shipping and Deliveries
We strive to dispatch orders as quickly as possible. Estimated delivery times are indicated in the shipping section of our website. Please note that these are only estimates and may vary due to external factors.
Shipping costs will be calculated and displayed before you confirm your order.
The risk of loss and title to the products will be transferred to you at the time of delivery to the carrier.
It is your responsibility to ensure that the shipping address provided is correct and complete. We are not responsible for delays or losses caused by incorrect or incomplete addresses.

8. Returns and Refund Policy
We want you to be satisfied with your purchase. If for any reason you are not, you may request a return within 15 days of receiving your order.
To be eligible for a return, the item must be unused and in the same condition in which you received it, and in its original packaging.
Customized items (printed or embroidered at the customer's request) and underwear are not eligible for return for hygiene or customization reasons, unless they have a manufacturing defect.
Return shipping costs are the responsibility of the customer, unless the product received is defective or incorrect.
Refunds will be processed through the same payment method used in the original purchase, within 7 business days after receipt and verification of the returned item.

9. Limitation of Liability
Conlogar S.A. will not be liable for any indirect, incidental, special, consequential, or punitive damages, including, without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of third parties on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use, or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence), or any other legal theory, whether or not we have been informed of the possibility of such damages, and even if a remedy set forth herein is found to have failed of its essential purpose.

10. Modifications to the Terms and Conditions
We reserve the right to modify these Terms and Conditions at any time. Any changes will be effective immediately upon posting on our website. It is your responsibility to review these Terms and Conditions periodically to be aware of updates. Continued use of our website after the posting of changes will constitute your acceptance of such changes.

11. Applicable Law and Jurisdiction
These Terms and Conditions are governed by and construed in accordance with the laws of Costa Rica, without regard to its conflict of law principles. You agree to submit to the exclusive jurisdiction of the courts located in Cartago, Costa Rica for the resolution of any dispute arising in connection with these Terms and Conditions.

12. Contact
If you have any questions about these Terms and Conditions, please contact us at camitexcr@gmail.com.
`
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        style={{
          background: 'none',
          border: 'none',
          color: '#e60026',
          textDecoration: 'underline',
          cursor: 'pointer',
          fontSize: 16,
          margin: '0 8px'
        }}
      >
        {lang === 'es' ? 'Términos y Condiciones' : 'Terms and Conditions'}
      </button>
      {open && (
        <div
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.35)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onClick={() => setOpen(false)}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 12,
              padding: 32,
              maxWidth: 420,
              width: '90%',
              boxShadow: '0 4px 24px rgba(0,0,0,0.13)',
              position: 'relative',
              maxHeight: '90vh',
              overflowY: 'auto'
            }}
            onClick={e => e.stopPropagation()}
          >
            <button
              onClick={() => setOpen(false)}
              style={{
                position: 'absolute',
                top: 12,
                right: 16,
                background: 'none',
                border: 'none',
                fontSize: 22,
                color: '#e60026',
                cursor: 'pointer'
              }}
              aria-label="Cerrar"
            >
              ×
            </button>
            <div style={{ whiteSpace: 'pre-line', color: '#222', fontSize: 16 }}>
              {terms[lang]}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default TermsPopup;
